import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'stavros';
const args = {};

export class Stavros extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
